export type ScrollBehavior = 'auto' | 'smooth'

/** Scroll one element to its actual bottom without affecting scrollable ancestors. */
export const scrollToBottom = (container: HTMLElement, behavior: ScrollBehavior = 'auto'): void => {
  const top = Math.max(0, container.scrollHeight - container.clientHeight)
  container.scrollTo({ top, behavior })
}
